export default function ClientsAcceleracao() {
  const clients = Array.from({ length: 26 }, (_, i) => ({
    id: i + 1,
    src: `/images/logos_empresas/${i + 1}.png`,
    alt: `Cliente ${i + 1}`
  }));

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            Empresas que saíram da improvisação e criaram <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500">vendas previsíveis</span> com a M4 Digital
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            Marcas que deixaram de depender da sorte e passaram a crescer com <strong>previsibilidade</strong> usando CRM, automação e inteligência artificial.
          </p>
        </div>

        {/* Static Grid - All 12 logos */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
          {clients.map((client) => (
            <div
              key={client.id}
              className="flex items-center justify-center p-4 sm:p-5 lg:p-6 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300"
            >
              <img
                src={client.src}
                alt={client.alt}
                className="h-16 sm:h-20 lg:h-24 w-auto max-w-full object-contain filter grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* Bottom Section - Stats and Segments */}
        <div className="mt-12 sm:mt-16 lg:mt-20 text-center px-4">
          {/* Company Stats - Single Line */}
          <p className="text-base sm:text-lg md:text-xl text-gray-700 font-medium mb-4">
            + de <span className="text-orange-600 font-bold text-xl sm:text-2xl">1.500 empresas</span> já estruturaram suas vendas com a M4 Digital
          </p>

          {/* Segments - Horizontal Line */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 text-sm sm:text-base text-gray-600">
            <span className="font-semibold text-gray-900">Segmentos atendidos:</span>
            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
              <span>Clínicas e estética</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
              <span>Educação</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
              <span>Franquias</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
              <span>Serviços locais</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
              <span>Indústria e varejo</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
